import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, createBlock as _createBlock } from "vue"
import _imports_0 from '@/common/assets/icon/sideBar/homeActive.svg'
import _imports_1 from '@/common/assets/icon/sideBar/home.svg'
import _imports_2 from '@/common/assets/icon/sideBar/historyActive.svg'
import _imports_3 from '@/common/assets/icon/sideBar/history.svg'
import _imports_4 from '@/common/assets/icon/sideBar/scan.svg'
import _imports_5 from '@/common/assets/icon/sideBar/walletActive.svg'
import _imports_6 from '@/common/assets/icon/sideBar/wallet.svg'
import _imports_7 from '@/common/assets/icon/sideBar/profileActive.svg'
import _imports_8 from '@/common/assets/icon/sideBar/profile.svg'


const _hoisted_1 = {
  key: 0,
  class: "img-active",
  src: _imports_0
}
const _hoisted_2 = {
  key: 1,
  src: _imports_1
}
const _hoisted_3 = {
  key: 0,
  class: "img-active",
  src: _imports_2
}
const _hoisted_4 = {
  key: 1,
  src: _imports_3
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "btn-scan" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_4 })
], -1)
const _hoisted_6 = {
  key: 0,
  class: "img-active",
  src: _imports_5
}
const _hoisted_7 = {
  key: 1,
  src: _imports_6
}
const _hoisted_8 = {
  key: 0,
  class: "img-active",
  src: _imports_7
}
const _hoisted_9 = {
  key: 1,
  src: _imports_8
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_router_outlet = _resolveComponent("ion-router-outlet")!
  const _component_ion_tab_button = _resolveComponent("ion-tab-button")!
  const _component_ion_tab_bar = _resolveComponent("ion-tab-bar")!
  const _component_ion_tabs = _resolveComponent("ion-tabs")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_tabs, {
        onIonTabsWillChange: _ctx.beforeTabChange,
        onIonTabsDidChange: _ctx.afterTabChange
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_router_outlet, { class: "main-content" }),
          _withDirectives(_createVNode(_component_ion_tab_bar, { slot: "bottom" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_tab_button, {
                tab: "dashboard",
                href: "/tabs/dashboard"
              }, {
                default: _withCtx(() => [
                  (_ctx.tabSelected === 'dashboard')
                    ? (_openBlock(), _createElementBlock("img", _hoisted_1))
                    : (_openBlock(), _createElementBlock("img", _hoisted_2))
                ]),
                _: 1
              }),
              _createVNode(_component_ion_tab_button, {
                tab: "history",
                href: "/tabs/history"
              }, {
                default: _withCtx(() => [
                  (_ctx.tabSelected === 'history')
                    ? (_openBlock(), _createElementBlock("img", _hoisted_3))
                    : (_openBlock(), _createElementBlock("img", _hoisted_4))
                ]),
                _: 1
              }),
              _createVNode(_component_ion_tab_button, {
                class: "scan-tab",
                tab: "transaction",
                href: "/tabs/transaction"
              }, {
                default: _withCtx(() => [
                  _hoisted_5
                ]),
                _: 1
              }),
              _createVNode(_component_ion_tab_button, {
                tab: "wallets",
                href: "/tabs/wallets/detail"
              }, {
                default: _withCtx(() => [
                  (_ctx.tabSelected === 'wallets')
                    ? (_openBlock(), _createElementBlock("img", _hoisted_6))
                    : (_openBlock(), _createElementBlock("img", _hoisted_7))
                ]),
                _: 1
              }),
              _createVNode(_component_ion_tab_button, {
                tab: "profile",
                href: "/tabs/profile"
              }, {
                default: _withCtx(() => [
                  (_ctx.tabSelected === 'profile')
                    ? (_openBlock(), _createElementBlock("img", _hoisted_8))
                    : (_openBlock(), _createElementBlock("img", _hoisted_9))
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 512), [
            [_vShow, _ctx.showTabBar]
          ])
        ]),
        _: 1
      }, 8, ["onIonTabsWillChange", "onIonTabsDidChange"])
    ]),
    _: 1
  }))
}